import { cn } from "@utils";

const ROW_COUNT = 24;
const PULSE = "bg-zinc-200 rounded-md animate-pulse";
const BORDER = "border-b border-zinc-200";

const SkeletonRows = ({ columns, selectable, hasPinnedLeft, hasRowActions }) =>
  Array.from({ length: ROW_COUNT }, (_, i) => {
    const isLast = i === ROW_COUNT - 1;
    return (
      <tr key={i} className="bg-white">
        {selectable && (
          <td
            className={cn(
              "sticky h-16 left-0 z-10 px-7 sm:w-12 sm:px-6 bg-inherit",
              !isLast && BORDER,
            )}
          >
            <div className={cn("h-4 w-4", PULSE)} />
          </td>
        )}
        {hasPinnedLeft && (
          <td
            className={cn(
              "sticky h-14 left-0 z-10 px-4 w-12 bg-inherit border-r border-zinc-200",
              !isLast && BORDER,
            )}
          >
            <div className={cn("h-4 w-4 mx-auto", PULSE)} />
          </td>
        )}
        {columns.map((col, j) => (
          <td
            key={j}
            className={cn(
              "h-14 max-h-14 whitespace-nowrap px-3 flex-block items-center text-sm",
              col.right && "text-right",
              !isLast && BORDER,
            )}
            style={{
              maxWidth: col.width || "200px",
              minWidth: col.width || "200px",
            }}
          >
            <div className={cn("h-4 w-4/5", PULSE)} />
          </td>
        ))}
        {hasRowActions && (
          <td
            className={cn(
              "h-14 bg-inherit px-3 text-sm border-l border-zinc-200 sticky right-0",
              !isLast && BORDER,
            )}
          >
            <div className={cn("h-4 w-16", PULSE)} />
          </td>
        )}
      </tr>
    );
  });

export default SkeletonRows;
